export default __webpack_public_path__ + "static/media/YouTubeWhite.7a12107a.svg";